import { API_ROUTE } from "../constants/workerConstants";
import AxiosInstance from "./http.handlers";

export const GetInvAssemblyCategoryTypes = async (headers) => {
  return await AxiosInstance.get(`${API_ROUTE.InvAssemblyCategoryType.CRUD}`, {
    headers,
  })
    .then((response) => response)
    .catch((error) => error);
};

export const CreateInvAssemblyCategoryType = async (payload, headers) => {
  return await AxiosInstance.post(
    `${API_ROUTE.InvAssemblyCategoryType.CRUD}`,
    payload,
    {
      headers,
    }
  )
    .then((response) => response)
    .catch((error) => error);
};

export const GetInvAssemblyCategoryType = async (id, headers) => {
  return await AxiosInstance.get(`${API_ROUTE.InvAssemblyCategoryType.CRUD}/${id}`, {
    headers,
  })
    .then((response) => response)
    .catch((error) => error);
};

export const updateInvAssemblyCategoryType = async (id, payload, headers) => {
  return await AxiosInstance.put(
    `${API_ROUTE.InvAssemblyCategoryType.CRUD}/${id}`,
    payload,
    {
      headers,
    }
  )
    .then((response) => response)
    .catch((error) => error);
};
